import React, { Fragment, } from 'react';
import {
  BrowserRouter as Router,
  Route,
  Switch,
} from 'react-router-dom'

//Page
import DashboardPage from './Components/Pages/DashboardPage'
import HomePage from './Components/Pages/HomePage'
import UpdateProfile_AuthPage from './Components/Pages/UpdateProfile_AuthPage'
import NotFound from './Components/Pages/NotFound'
import {AuthProvider} from './contex/authContex'





function RouterManage() {
 
  return (
    <Fragment>
      <AuthProvider>
        <Router>
          <Switch> 
              <Route path="/UpdateProfle_Auth">
                <UpdateProfile_AuthPage/>
              </Route>
              <Route path="/Home">
                <HomePage/>
              </Route>
              <Route path="/">
                <DashboardPage/>
              </Route>
          </Switch>
        </Router>
      </AuthProvider>
    </Fragment>
  );
}

export default  RouterManage;
